import React from 'react';
import { Link } from 'react-router-dom';

const AvatarInfoBanner = ({ onDismiss }) => {
  return (
    <div className="avatar-info-banner">
      <div className="avatar-info-content">
        <div className="avatar-info-text">
          <strong>Avatar Interactivo</strong>
          <p>
            Al interactuar con este avatar, se procesan datos t&eacute;cnicos (IP, identificadores
            de sesi&oacute;n) para la provisi&oacute;n del servicio y prevenci&oacute;n de abuso, bajo
            inter&eacute;s leg&iacute;timo (Art. 6.1.f RGPD). El audio de voz se procesa transitoriamente
            y se elimina inmediatamente.{' '}
            <Link to="/privacidad" className="avatar-info-link">M&aacute;s informaci&oacute;n</Link>
          </p>
        </div>
        <button className="avatar-info-btn" onClick={onDismiss}>
          Entendido
        </button>
      </div>
    </div>
  );
};

export default AvatarInfoBanner;
